__turbopack_context__.v({
  "label": "spell-view-module__mSMXkG__label",
  "sourceToggle": "spell-view-module__mSMXkG__sourceToggle",
});
